import { useTranslation } from 'react-i18next'

import { ColorSwatch, Flex, Typography } from '@percent/lemonade'
import type { GivingThemeColours, GivingThemeConfigValue } from '@percent/admin-dashboard/api/types'

type ColorSwatchGridProps = {
  colours: GivingThemeConfigValue['colours']
  overlayGradientPercentage: number
}

export function ColorSwatchGrid({ colours, overlayGradientPercentage }: ColorSwatchGridProps) {
  const { t } = useTranslation()

  return (
    <Flex direction="column" gap={3}>
      <Flex gap={3} wrap="wrap">
        {(Object.entries(colours) as Array<[keyof GivingThemeColours, string]>).map(([key, value]) => (
          <Flex key={key} direction="column" align="center" gap={1}>
            <ColorSwatch color={value} size={24} radius="sm" />
            <Typography variant="small" $color="gray600">
              {t(`partnerConfig.branding.colour.${key}`)}
            </Typography>
            <Typography variant="small" $color="gray500">
              {value}
            </Typography>
          </Flex>
        ))}
      </Flex>
      <Typography variant="small" $color="gray600">
        {t('partnerConfig.branding.overlayGradient', { value: overlayGradientPercentage })}
      </Typography>
    </Flex>
  )
}
